/**
 * @file: SystemMessageText.tsx
 *
 * System messages (room.dismissed, members.invited, …) render as centered
 * grey text rather than a bubble.
 */

import { Typography } from '@euler/app/components/typography';
import { chatNotificationText } from '@euler/app/flows/chat/utils/chatNotificationText';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChatNotificationPayload } from '@euler/model/chat';
import { IdType } from '@euler/model/common';
import { FC, memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

export const SystemMessageText: FC<{
  payload: ChatNotificationPayload;
  myPlatformUserId: IdType;
  style?: StyleProp<ViewStyle>;
}> = memo(({ payload, myPlatformUserId, style }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View style={[{ alignItems: 'center', paddingHorizontal: rpx(16) }, style]}>
      <Typography.Text
        size={rpx(11)}
        color="#9ca3af"
        style={{
          textAlign: 'center',
          fontFamily: FontFamily.NotoSans.Regular,
        }}
      >
        {chatNotificationText(payload, myPlatformUserId)}
      </Typography.Text>
    </View>
  );
});
